import PropTypes from 'prop-types';
import React from 'react';

import ProductsTableContainer from '../../../ProductsTable/ProductsTableContainer';
import TableCardContainer from '../../../TableCard/TableCardContainer';

const DetailViewComponent = ({
  selectedMenuItem,
  category,
  subcategory,
  isViewAllActive,
}) => (
  <TableCardContainer
    {...{
      category: category.name,
      subcategory: subcategory.name,
      expanded: true,
    }}
  >
    <ProductsTableContainer
      {...{ selectedMenuItem, category, subcategory, isViewAllActive }}
    />
  </TableCardContainer>
);

DetailViewComponent.propTypes = {
  category: PropTypes.object.isRequired,
  subcategory: PropTypes.object,
  isViewAllActive: PropTypes.bool,
  selectedMenuItem: PropTypes.object.isRequired,
};

export default DetailViewComponent;
